import React from 'react';
export default function Logo({ height = 32 }) {
  return (
    <img src="/logo.svg" alt="Ringostat" height={height} style={{ verticalAlign: 'middle', borderRadius: 6, maxHeight: height }} />
  );
}
